import Ajax from '@/lib/ajax'
import Appconst from '@/lib/appconst'
export default {
  /**
   * 获取用户列表
   * @param pageSize
   * @param currentPage
   * @param filter
   */
  getUsers(pageSize: number, currentPage: number, filter?: string) {
    let params = {
      Filter: filter,
      MaxResultCount: pageSize,
      SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * pageSize,
      Sorting: 'creationTime desc',
    }
    return Ajax.get(`/api/identity/users`, {
      params: params,
    })
  },
  /**
   * 创建用户
   * @param data
   */
  postUser(data: any) {
    return Ajax.post(`/api/identity/users`, data)
  },
  /**
   * 获取用户信息
   * @param id
   */
  getUser(id: any) {
    return Ajax.get(`/api/identity/users/${id}`)
  },
  /**
   * 修改用户信息
   * @param id
   */
  putUser(id: any, data: any) {
    return Ajax.put(`/api/identity/users/${id}`, data)
  },
  /**
   * 删除用户
   * @param id
   */
  deleteUser(id: string) {
    return Ajax.delete(`/api/identity/users/${id}`)
  },
  getRoles(id: any) {
    return Ajax.get(`/api/identity/users/${id}/roles`)
  },
  /**
   * 禁用用户
   * @param id
   */
  disabledUser(id: string) {
    return Ajax.put(`/api/eves/account/lockout/${id}`, {}, { baseURL: Appconst.token_root })
  },
  /**
   * 启用用户
   */
  enableUser(id: string) {
    return Ajax.put(
      `/api/eves/account/unlockout/${id}`,
      {},
      { baseURL: Appconst.token_root }
    )
  },
  getStorePermission(id: string) {
    return Ajax.get(`/api/shopPermission/${id}`, { baseURL: Appconst.token_root})
  },
  // 店铺权限
  addStorePermission(id: string, shopIds: any[]) {
    let obj = {
      id,
      shopIds
    }
    return Ajax.post(`/api/shopPermission`, obj, { baseURL: Appconst.token_root})
  }
}
